<template>
  <div class="top-tracks" id="top-tracks">
    <div class="container">
      <div class="row">
        <div class="col-12 text-center">
          <h2 class="top-tracks-title">Neki od naših nastupa</h2>
        </div>
      </div>
      <div class="row">
        <div class="col-4">
          <div class="top-video-holder" data-aos="fade-right">
            <div class="youtube" data-embed="7WTulwhNDO8">
              <div class="play-button"></div>
            </div>
            <div class="top-video-holder-bottom">
              <h4>Dodji</h4>
            </div>
          </div>
        </div>
        <div class="col-4">
          <div class="top-video-holder" data-aos="fade-up">
            <div class="youtube" data-embed="5XG7p0iqprs">
              <div class="play-button"></div>
            </div>
            <div class="top-video-holder-bottom">
              <h4>Bosnom behar probeharao</h4>
            </div>
          </div>
        </div>
        <div class="col-4">
          <div class="top-video-holder" data-aos="fade-left">
            <div class="youtube" data-embed="D3TVvEtpjFo">
              <div class="play-button"></div>
            </div>
            <div class="top-video-holder-bottom">
              <h4>Ne mogu bez tebe više</h4>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 text-center">
          <router-link to="/galerija" class="btn top-more-btn">Pogledaj još</router-link>
        </div>
      </div>
    </div>
  </div>

</template>

<script>

  export default {
    mounted() {
      var youtube = document.querySelectorAll( ".youtube" );
      for (var i = 0; i < youtube.length; i++) {
        // thumbnail image source
        let source = "https://img.youtube.com/vi/" + youtube[i].dataset.embed + "/hqdefault.jpg";

        // Load the image asynchronously
        var image = new Image();
        image.src = source;
        image.addEventListener( "load", function() {
          youtube[ i ].appendChild( image );
        }( i ) );


        youtube[i].addEventListener( "click", function() {

          var iframe = document.createElement( "iframe" );

          iframe.setAttribute( "frameborder", "0" );
          iframe.setAttribute( "allowfullscreen", "" );
          iframe.setAttribute( "src", "https://www.youtube.com/embed/"+ this.dataset.embed +"?rel=0&showinfo=0&autoplay=1" );

          this.innerHTML = "";
          this.appendChild( iframe );
        } );
      }
    }
  }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/TopTracks.vue